import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ds_print_order_labels_options_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { include?: string[], exclude?: string[], full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { option?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_print_order_labels_options_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { include?: string[], exclude?: string[], full_text_search?: string, $keys: string[] }): Promise<{ result?: { option?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_print_order_labels_options_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      include?: string[], exclude?: string[], full_text_search?: string    }) {
      return false;
    }
}
